import React from 'react'
import { Card, CardContent } from '../layout/Card'
import './styles/table.sass'

type TableProps = {
  children: HTMLTableElement; 
  assets?: any;
  noShadow?: boolean;
}
const Table = ({ children, assets, noShadow }: TableProps) => {
  const base = 'table'
  const modifiers = (assets ? `${base}--assets` : '')

  return (
    <Card className={`table ${modifiers}`} noShadow>
      <CardContent>
        {children}
      </CardContent>
    </Card>
  )
}

export { Table }
